import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class UnidadNegocioService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  obtenerUnidadNegocio(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query($entidad:unidad_negocioInputType){
          unidad_negocio {
            obtenerUnidadNegocio (entidad:$entidad){
              mensajes {
                codigo
                contexto
                tipo
                texto
              }
              respuesta {
                registros {
                  codigo
                  nombre
                  activado
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.unidad_negocio.obtenerUnidadNegocio
        callback({ mensajes, respuesta })
      }
    );
  }
}
